import { Select, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled";
import CubeIcon from "@entrilia/shared/icons/CubeIcon";
import type { DataSetInfo } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { selectDataSetSettings } from "../../../../store/selectors/clientSettingsSelectors";
import { selectCurrentDataSetId } from "../../../../store/selectors/metaDataSelectors";
import { changeDataSet } from "../../../../store/thunks/metaDataThunks";
import { useFieldDestination } from "./useFieldDestination.ts";

export default function DataSetSelector({ disabled }: { disabled: boolean }) {
  const dispatch = useAppDispatch();
  const dataSets = useSelector(selectDataSetSettings);
  const selectedDataSet = useSelector(selectCurrentDataSetId);
  const { stopAddingFields } = useFieldDestination();

  const handleChange = useCallback(
    (id: string) => {
      const ds = dataSets.find((ds) => ds.id === id);
      if (ds?.id) {
        stopAddingFields();
        dispatch(changeDataSet(ds.id));
      }
    },
    // eslint-disable-next-line @eslint-react/exhaustive-deps
    [dataSets, stopAddingFields]
  );

  if (!selectedDataSet) {
    return null;
  }

  return (
    <Select
      fullWidth
      value={selectedDataSet}
      sx={{ ".MuiSelect-select": { py: 1 } }}
      onChange={(evt) => handleChange(evt.target.value)}
      disabled={disabled}
    >
      {dataSets.map((value) => (
        <MenuItemStyled key={value.id} value={value.id}>
          <DataSetItem value={value} />
        </MenuItemStyled>
      ))}
    </Select>
  );
}

function DataSetItem({ value }: { value: DataSetInfo }) {
  return (
    <Stack direction="row" useFlexGap spacing={1.5} sx={{ flex: 1, alignItems: "center" }}>
      <CubeIcon sx={(theme) => ({ color: theme.palette.secondary.main })} />
      <Typography>{value.name}</Typography>
    </Stack>
  );
}
